import React from 'react';

import './DistributionTransaction.scss';

import Button from '../Button/Button';
import { useDispatch } from 'react-redux';
import { setProgress } from '../../../redux/modules/progress';

export const DistributionTransaction = ({ proceed, closeModal }) => {
  const dispatch = useDispatch();

  return (
    <div className="e2e-sell-all-shares-closed-to-new-investors-container">
      <div className="sell-all-shares-closed-to-new-investors-heading">
        Important Information About Your Distribution
      </div>

      <div className="sell-all-shares-closed-to-new-investors-disclosure">
        Our records indicate that you have systematic distributions set up for
        your RMD-eligible account(s). Please keep in mind that your current
        transaction will be in addition to any distribution you have scheduled.
        This could result in taking more than your Required Minimum Distribution
        for the current year.
      </div>

      <div className="sell-all-shares-closed-to-new-investors-button-container">
        <a
          className="trp-pdf-link e2e-sell-all-shares-closed-to-new-investors-cancel-button sell-all-shares-closed-to-new-investors-cancel-button"
          id="e2e-sell-all-shares-closed-to-new-investors-modal-cancel"
          onClick={() => {
            closeModal();
          }}
        >
          Return to Transaction
        </a>

        <Button
          buttonType="primary"
          className="btn-trp-primary e2e-sell-all-shares-closed-to-new-investors-confirm-button sell-all-shares-closed-to-new-investors-confirm-button"
          id={`sell-all-shares-closed-to-new-investors-modal-ok-btn`}
          onClick={() => {
            proceed();
            dispatch(setProgress(3));
          }}
          stylename="sell-all-shares-closed-to-new-investors-ok-button"
        >
          Proceed with IRA Distribution
        </Button>
      </div>
    </div>
  );
};

export default DistributionTransaction;
